<template>
  <div>
    <PageTitle title="Summary Details" />
    <v-container fluid class="lighten-12 content">
      <v-row>
        <v-col sm="5" md="5" lg="3">
          <DatePicker
            :labelname="'Date'"
            v-model="searchDate"
            @input="getAllsammarydata(searchDate)"
            :max="Datemax"
          />
        </v-col>

        <v-col sm="5" md="5" lg="3">
          <v-btn
            hidden
            small
            class="text-white btn_gray w-100 d-none d-sm-flex"
            v-print="printQr"
            >Print <v-icon right dark> mdi-printer </v-icon></v-btn
          >
        </v-col>

        <DailySummary
          id="summaryData"
          style="display: none"
          :DateTime="searchDate"
          class="test1"
          :Data="summaryData"
        />
      </v-row>
      <v-card-title class="d-flex justify-space-between"> </v-card-title>
      <v-row>
        <v-row> </v-row>

        <v-col   sm="12" md="6" lg="6">
          <v-card height="100%" class="mb-3 pa-4">
            <v-row>
              <!-- <v-col cols="5" >
                <v-img
                  class="animatedSvg"
                  src="@/assets/order.png"
                  height="100%"
                  width="100%"
                ></v-img>
              </v-col> -->
              <v-col cols="12" >
                <v-row>
                  <v-col cols="12"
                    ><p class="font-weight-black headerStyle">🛒 Order</p></v-col
                  >
                  <v-col cols="6"
                    ><b>Total Amount : </b>
                    {{
                      summaryData.order.totalAmount
                        ? summaryData.order.totalAmount
                        : "0.00" | formatCurrency
                    }}</v-col
                  >

                  <v-col cols="6"
                    ><b>Paid Amount : </b
                    >{{
                      summaryData.order.paidAmount
                        ? summaryData.order.paidAmount
                        : "0.00" | formatCurrency
                    }}</v-col
                  >

                  <v-col cols="6"
                    ><b>Cash Amount : </b>
                    {{
                      summaryData.order.cashAmount
                        ? summaryData.order.cashAmount
                        : "0.00" | formatCurrency
                    }}
                  </v-col>

                  <v-col cols="6"
                    ><b>Card Amount : </b>
                    {{
                      summaryData.order.CardAmount
                        ? summaryData.order.CardAmount
                        : "0.00" | formatCurrency
                    }}</v-col
                  >
                  <v-col cols="6"
                    ><b>Pending Cash Amount : </b>
                    {{
                      summaryData.order.PendingCashAmount
                        ? summaryData.order.PendingCashAmount
                        : "0.00" | formatCurrency
                    }}
                  </v-col>

                  <v-col cols="6"
                    ><b>Pending Card Amount : </b>
                    {{
                      summaryData.order.PendingCardAmount
                        ? summaryData.order.PendingCardAmount
                        : "0.00" | formatCurrency
                    }}</v-col
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col sm="12" md="6" lg="6">
          <v-card height="100%" class="mb-3 pa-4">
            <v-row>
              <!-- <v-col cols="5" sm="5" md="5" lg="5">
                <v-img
                  class="animatedSvg"
                  src="@/assets/rese.png"
                  height="100%"
                  width="100%"
                ></v-img>
              </v-col> -->
              <v-col cols="12">
                <v-row>
                  <v-col cols="12">
                    <p class="font-weight-black headerStyle">🛎️ Reservation</p>
                  </v-col>
                  <v-col cols="6"
                    ><b>Total Amount : </b
                    >{{
                      summaryData.reservation.totalAmount
                        ? summaryData.reservation.totalAmount
                        : "0.00" | formatCurrency
                    }}</v-col
                  >

                   <v-col cols="6"
                    ><b>Order Amount : </b
                    >{{
                      summaryData.reservation.orderAmount
                        ? summaryData.reservation.orderAmount
                        : "0.00" | formatCurrency
                    }}</v-col
                  >

                   <v-col cols="6"
                    ><b>Room Amount : </b
                    >{{
                      summaryData.reservation.roomAmount
                        ? summaryData.reservation.roomAmount
                        : "0.00" | formatCurrency
                    }}</v-col
                  >

                  <v-col cols="6"
                    ><b>Paid Amount : </b
                    >{{
                      summaryData.reservation.paidAmount
                        ? summaryData.reservation.paidAmount
                        : "0.00" | formatCurrency
                    }}</v-col
                  >
                  <v-col cols="6"
                    ><b>Card Amount : </b
                    >{{
                      summaryData.reservation.CardAmount
                        ? summaryData.reservation.CardAmount
                        : "0.00" | formatCurrency
                    }}</v-col
                  >
                  <v-col cols="6"
                    ><b>Cash Amount : </b
                    >{{
                      summaryData.reservation.cashAmount
                        ? summaryData.reservation.cashAmount
                        : "0.00" | formatCurrency
                    }}</v-col
                  >
                   <v-col cols="6"
                    ><b>Pending Amount : </b
                    >{{
                     (summaryData.reservation.totalAmount-summaryData.reservation.paidAmount)| formatCurrency
                    }}</v-col
                  >

                  <v-col cols="6"
                    ><b>Pending Card Amount : </b
                    >{{
                      summaryData.reservation.PendingCardAmount
                        ? summaryData.reservation.PendingCardAmount
                        : "0.00" | formatCurrency
                    }}</v-col
                  >
                  <v-col cols="6"
                    ><b>Pending Cash Amount : </b
                    >{{
                      summaryData.reservation.PendingCashAmount
                        ? summaryData.reservation.PendingCashAmount
                        : "0.00" | formatCurrency
                    }}</v-col
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col  sm="12" md="12" lg="12">
          <v-card>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12">
                  <span class="font-weight-black headerStyle">Full Total</span>
                </v-col>
                <v-col cols="4" sm="12" md="4" lg="4"><h2>Total Amount</h2></v-col>
                <v-col cols="4 " sm="12" md="4" lg="4"><h2>{{
                  summaryData.total_amount
                    ? summaryData.total_amount
                    : "0.00" | formatCurrency
                }}</h2></v-col>
                <v-col cols="4" sm="12" md="4" lg="4"></v-col>
                <v-col cols="4" sm="12" md="4" lg="4"><h2>Settled Amount</h2></v-col>
                <v-col cols="4" sm="12" md="4" lg="4"><h2>{{
                  summaryData.settled_amount
                    ? summaryData.settled_amount
                    : "0.00" | formatCurrency
                }}</h2></v-col>
                <v-col cols="4" sm="12" md="4" lg="4"></v-col>

              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DailySummary from "../../components/PrintTemplates/DailySummaryTemplate";

import TableFilters from "@/components/base/TableFilters";
import * as moment from "moment/moment";
import DatePicker from "@/components/base/DateComponent.vue";

export default {
  data: () => ({
    searchDate: moment(new Date())
      .subtract(1, "days")
      .format("YYYY-MM-DD"),
    summaryData: [],
    filter: moment(new Date()).format("YYYY-MM-DD")
  }),
  components: { TableFilters, DatePicker, DailySummary },

  methods: {
    async getAllsammarydata(value) {
      await this.$store
        .dispatch("report/getSummaryReports", value)
        .then(res => {
          this.summaryData = res.data.data;
        })
        .catch(err => {});
    }
  },
  computed: {
    printQr() {
      return {
        id: "summaryData",
        popTitle: "Product Details"
      };
    }
  },

  created() {
    this.getAllsammarydata(this.searchDate);
  }
};
</script>
<style scoped>
.headerStyle {
  font-size: 25px;
}
</style>
